module.exports = __webpack_public_path__ + "img/5.4-Table-Grouped.00d3de44.png";